export const DASHBOARD_ROLES = {
    all: 'user-dashboard',
    procurement: 'user-procurement-dashboard',
    invoice: 'user-invoice-dashboard',
    outgoingInvoice: 'user-outgoing-invoice-dashboard',
    einvoice: 'user-einvoice-dashboard',
    supplier: 'user-supplier-dashboard'
} as const

export type DashboardType = keyof Omit<typeof DASHBOARD_ROLES, 'all'>

const dashboardTypes: DashboardType[] = [
    'procurement',
    'invoice',
    'outgoingInvoice',
    'einvoice',
    'supplier'
]

export function hasDashboardAccess(roles: string[], dashboard: DashboardType) {
    if (roles.includes('user-admin')) return true
    if (roles.includes(DASHBOARD_ROLES.all)) return true
    return roles.includes(DASHBOARD_ROLES[dashboard])
}

export function hasAnyDashboardAccess(roles: string[]) {
    return dashboardTypes.some((dashboard) => hasDashboardAccess(roles, dashboard))
}
